import { useEffect, useRef } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';
import { BottomArrowIcon } from '@/components/UI/svg/Icons/EFArrowDown';
import { TopArrowIcon } from '@/components/UI/svg/Icons/EFArrowUp';
import NextImage from '@/components/NextImage';

const temp_unit: any = {
    us: 'f',
    ca: 'c',
    cn: 'c',
    za: 'c',
    au: 'c',
};

export default function E() {
    const { useLang, useRouter, useState } = useGlobal();
    const { t } = useLang('wave2portableairconditioner');
    const { locale } = useRouter();
    const kvRef: any = useRef(null);
    const videoRef1: any = useRef(null);
    // const videoRef2: any = useRef(null);
    const [enter, setEnter] = useState(false);

    useEffect(() => {
        const layoutH = typeof window !== 'undefined' ? window?.innerHeight : 1080;

        AniContainer.create({
            triggerElement: '.wave2-detail-E',
            triggerHook: 1,
            offset: '123%',
            onEnter: () => {
                setEnter(true);
                if (videoRef1) {
                    videoRef1?.current?.play();
                }
            },
            onLeave: () => {
                setEnter(false);
                if (videoRef1) {
                    videoRef1?.current?.setCurrentTime(0);
                    videoRef1?.current?.pause();
                }
            },
        });

        AniContainer.create({
            asyncFromTo: [
                ['.wave2-detail-E .viewport-wrapper .ani-wrapper-1', { opacity: 1 }, { opacity: 0 }, 1],
                ['.wave2-detail-E .viewport-wrapper .ani-wrapper-2', { opacity: 0 }, { opacity: 1 }, 1],
                ['.wave2-detail-E .viewport-wrapper .text', { opacity: 1 }, { opacity: 0 }, 1],
            ],
            asyncTimeLine: [0, 0, 0],
            triggerElement: '.wave2-detail-E .viewport-wrapper',
            triggerHook: 1,
            offset: layoutH * 1.7,
            duration: 300,
        });

        // AniContainer.create({
        //     triggerElement: '.wave2-detail-E .viewport-wrapper',
        //     triggerHook: 1,
        //     offset: layoutH * 1.7,
        //     duration: layoutH * 2,
        //     onProcess: (process: number) => {
        //         if (process && videoRef2.current) {
        //             const duration: number = videoRef2.current?.current?.duration;
        //             videoRef2.current.setCurrentTime(Math.floor(duration * process * 100) / 100 || 0);
        //         }
        //     },
        // });
        AniContainer.create({
            asyncFromTo: [
                ['.wave2-detail-E .text-box-cool', { opacity: 0 }, { opacity: 1 }, 3],
                ['.wave2-detail-E .img-cool', { opacity: 0 }, { opacity: 1 }, 4],
                ['.wave2-detail-E .text-box-cool', { opacity: 1 }, { opacity: 0 }, 2],
                ['.wave2-detail-E .img-cool', { opacity: 1 }, { opacity: 0 }, 4],
                ['.wave2-detail-E .text-box-hot', { opacity: 0 }, { opacity: 1 }, 2],
                ['.wave2-detail-E .img-hot', { opacity: 0 }, { opacity: 1 }, 2],
            ],
            asyncTimeLine: [1, 1, 5, 5, 8, 8],
            triggerElement: '.wave2-detail-E .viewport-wrapper',
            triggerHook: 1,
            offset: '165%',
            duration: '200%',
        });
    }, []);

    return (
        <div className={`wave2-detail-E ${css.wave2DetailE}`}>
            <div className="viewport-wrapper">
                <div className="img-wrapper">
                    <div className="ani-wrapper-1">
                        <EFVideo
                            ref={videoRef1}
                            sources={['/video/wave2/pc/section_e.webm', '/video/wave2/pc/section_e.mp4']}
                            width="100%"
                            height="100%"
                            loop={false}
                            autoPlay={false}
                        />
                    </div>

                    <div className="ani-wrapper-2">
                        {/* <EFVideo
                            className="video-2"
                            ref={videoRef2}
                            sources={[
                                `/video/wave2/pc/section_f_${temp_unit[locale] || temp_unit.ca}.webm`,
                                `/video/wave2/pc/section_f_${temp_unit[locale] || temp_unit.ca}.mp4`,
                            ]}
                            width="100%"
                            height="100%"
                            loop={false}
                            autoPlay={false}
                        /> */}
                        <div className="img-box img-cool">
                            <NextImage
                                webpSrc={require('@publicLocal/wave2/detail/pc/e_cool.webp')}
                                src={require('@publicLocal/wave2/detail/pc/e_cool.jpg')}
                                alt={t('detail.sectionG_2')}
                                aria-label={t('detail.sectionG_2')}
                            />
                        </div>
                        <div className="img-box img-hot">
                            <NextImage
                                webpSrc={require('@publicLocal/wave2/detail/pc/e_hot.webp')}
                                src={require('@publicLocal/wave2/detail/pc/e_hot.jpg')}
                                alt={t('detail.sectionG_num')}
                                aria-label={t('detail.sectionG_num')}
                            />
                        </div>
                        <div className={`text-box-2`}>
                            <div className="text-box-cool">
                                <p className="cooling-text">{t('detail.sectionG_1')}</p>
                                <p className="num-box">
                                    <BottomArrowIcon height="44px" width="19px" />
                                    <span className="num-text">{t('detail.sectionG_2')}</span>
                                </p>
                            </div>
                            <div className="text-box-hot">
                                <p className="cooling-text">{t('detail.sectionG_hot')}</p>
                                <p className="num-box">
                                    <TopArrowIcon height="44px" width="19px" />
                                    <span className="num-text num-text-hot">{t('detail.sectionG_num')}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={`box-text ${enter ? 'enter' : ''}`}>
                        <p className="text">
                            {t.rich('detail.sectionB_3', {
                                line0: (text0: any) => <span className="text-white">{text0}</span>,
                                line1: (text1: any) => <span className="text-blue">{text1}</span>,
                                line3: (text3: any) => <em className="text-other">{text3}</em>,
                                line2: (text2: any) => <span className="text-orange">{text2}</span>,
                            })}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
